<template>
  <div>
    <v-modal
      :position="!screen.breakPoint.tabPort ? 'bottom' : 'top'"
      :fit-content="!screen.breakPoint.tabPort"
      :animation="!screen.breakPoint.tabPort ? 'slide-up' : 'slide-down'"
      :full="!screen.breakPoint.tabPort"
      handle-click-bg
      v-model="show"
    >
      <template #header>
        {{$t('components.ResetPassword.title')}}
      </template>

      <div class="text--center">
        <p class="mb-2 text--left mw400" >{{ $t('components.ResetPassword.text') }}</p>
        <v-input v-model="oldPass"
                 class="mb-2"
                 :placeholder="$t('components.ResetPassword.oldPass')"
                 :type-name="typePassword ? 'password' : null"
                 icon-type="button"
                 icon-position="right"
                 :icon="typePassword ? 'icon-eye' : 'icon-crossed-out-eye'"
                 @iconClick="typePassword = !typePassword"/>
        <v-input v-model="newPass"
                 :placeholder="$t('components.ResetPassword.newPass')"
                 :type-name="typePasswordNew ? 'password' : null"
                 icon-type="button"
                 icon-position="right"
                 :icon="typePasswordNew ? 'icon-eye' : 'icon-crossed-out-eye'"
                 @iconClick="typePasswordNew = !typePasswordNew" class="mb-2"/>
        <v-input v-model="newPass2"
                 :placeholder="$t('components.ResetPassword.newPass2')"
                 :type-name="typePasswordNew2 ? 'password' : null"
                 icon-type="button"
                 icon-position="right"
                 :icon="typePasswordNew2 ? 'icon-eye' : 'icon-crossed-out-eye'"
                 @iconClick="typePasswordNew2 = !typePasswordNew2"
                 class="mb-2"/>
        <v-button width="full" @click="updatePassword()">{{ $t('components.ResetPassword.button') }}</v-button>
      </div>
    </v-modal>
  </div>
</template>

<script>
import vModal from '@/ui/modals/vModal'

import screen from '@/mixins/screen'

import VInput from '@/ui/controls/vInput'
import VButton from '@/ui/controls/vButton'
import { ResetPasswordGQL } from '@/graphql/mutations'
import { notifyGraphqlError } from '@/mixins/handleGraphqlError'

export default {
  mixins: [screen, notifyGraphqlError],
  data () {
    return {
      typePassword: true,
      typePasswordNew: true,
      typePasswordNew2: true,
      oldPass: '',
      newPass: '',
      newPass2: ''
    }
  },

  methods: {
    resetDefault () {
      this.oldPass = ''
      this.newPass = ''
      this.newPass2 = ''
    },
    async updatePassword () {
      if (this.newPass !== this.newPass2) {
        return this.$notify({
          message: this.$t('errors.code.ResetPassword.notSame'),
          type: 'error'
        })
      }
      try {
        await this.$apollo.mutate({
          mutation: ResetPasswordGQL,
          variables: {
            params: {
              oldPass: this.oldPass,
              newPass: this.newPass
            }
          }
        })

        this.$notify({ message: this.$t('components.ResetPassword.success') })
        this.resetDefault()
        this.show = false
      } catch (e) {
        this.notifyGraphqlError(e)
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  components: {
    VButton,
    VInput,
    vModal
  },

  computed: {
    show: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style>
.mw400{
  max-width: 400px;
}
</style>
